import { render, staticRenderFns } from "./QuickMessagesTable.vue?vue&type=template&id=3163b000&scoped=true"
import script from "./QuickMessagesTable.vue?vue&type=script&lang=js"
export * from "./QuickMessagesTable.vue?vue&type=script&lang=js"
import style0 from "./QuickMessagesTable.vue?vue&type=style&index=0&id=3163b000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3163b000",
  null
  
)

export default component.exports